import React from "react";
import {getUser} from "../helpers/jwt";
import dateUtils from "../helpers/dateUtils";
import { useTranslation } from 'react-i18next';

const PrintHeader = ({title}) => {

    const { t } = useTranslation();

    return (
        <div className={"print-header mb-3"}>
            <span className="text-secondary mr-1">{t("common.user")}</span>
            <span className="badge badge-primary mr-3">{getUser()}</span>
            <span className="text-secondary mr-1">{t("common.date")}</span>
            <span className="badge badge-primary mr-3">{dateUtils.getCurrentDate("-")}</span>
        </div>

    );
};

export default PrintHeader;
